import React, { useEffect, useCallback } from "react";
import { Alert } from "reactstrap";

import "./Alerts.css";

// Default time (ms) an alert stays on screen if no `timeout` is supplied.
const DEFAULT_ALERT_TIMEOUT_MS = 10000;

const Alerts = ({ alerts, setAlerts }) => {
  const onDismissAlert = useCallback(
    (a) => {
      setAlerts(alerts.filter((item) => item.id !== a.id));
    },
    [alerts, setAlerts]
  );

  useEffect(() => {
    const timers = alerts.map((alert) => {
      const timeout = alert.timeout ?? DEFAULT_ALERT_TIMEOUT_MS;
      if (timeout <= 0) return null; // explicit opt-out for sticky alerts
      return setTimeout(() => {
        onDismissAlert(alert);
      }, timeout);
    });

    return () => {
      timers.forEach((timer) => timer && clearTimeout(timer));
    };
  }, [alerts, onDismissAlert]);

  return (
    <div 
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '90%',
        maxWidth: '600px',
        zIndex: 9999,
        pointerEvents: 'auto'
      }}
    >
      {alerts?.map((alert) => (
        <Alert
          key={alert.id}
          color={alert.color}
          toggle={() => onDismissAlert(alert)}
          className="brand-alert"
        >
          {alert.message}
        </Alert>
      ))}
    </div>
  );
};

export default Alerts;